(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('SimPhoneDeleteController',SimPhoneDeleteController);

    SimPhoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'SimPhone'];

    function SimPhoneDeleteController($uibModalInstance, entity, SimPhone) {
        var vm = this;

        vm.simPhone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SimPhone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
